import { addDays, startOfISOWeek } from 'date-fns'
import type { Holiday, MissionStoreRecord, StrategicRegion, WeeklyAppointment } from './missionService.types'

// SL-mission endpoints not shipped yet (2026-04-25). The seed data here
// is the demo set the in-memory `missionService` boots with so dependent
// hooks (useScoutWeek, useStrategicRegions, useFixedAppointments,
// useMorningSync) have a non-empty render. Delete this file when the SL
// missions API replaces missionService — see Commander posture
// "FE only consumes."

const startOfWeek = startOfISOWeek(new Date())
export const isoForOffset = (offset: number) =>
  addDays(startOfWeek, offset).toISOString().split('T')[0]

export const initialMissionStore: MissionStoreRecord[] = [
  {
    id: 'mission-berlin-alpha',
    title: 'Berlin Enterprise Push',
    description: 'Focus on Tier 1 enterprise accounts in Berlin',
    status: 'active',
    leadCount: 24,
    region: 'Berlin',
    assignee: 'Maria Klein',
    startDate: '2025-02-03',
    endDate: '2025-02-21',
    scheduledDate: isoForOffset(0),
    scheduledTime: '09:00',
  },
  {
    id: 'mission-hamburg-expansion',
    title: 'Hamburg Expansion',
    description: 'Market expansion campaign for Hamburg metro area',
    status: 'active',
    leadCount: 18,
    region: 'Hamburg',
    assignee: 'Noah Vogt',
    startDate: '2025-02-05',
    endDate: '2025-02-19',
    scheduledDate: isoForOffset(1),
    scheduledTime: '11:00',
  },
  {
    id: 'mission-munich-product',
    title: 'Product Launch Support',
    description: 'Support new product launch in Munich',
    status: 'draft',
    leadCount: 12,
    region: 'Munich',
    assignee: 'Helena Scholz',
    startDate: '2025-02-10',
    endDate: '2025-02-25',
    scheduledDate: isoForOffset(2),
    scheduledTime: '14:00',
  },
  {
    id: 'mission-rhine-industrial',
    title: 'Rhine Industrial Coverage',
    description: 'Industrial focus for NRW corridor',
    status: 'completed',
    leadCount: 30,
    region: 'Cologne',
    assignee: 'Felix Braun',
    startDate: '2025-01-15',
    endDate: '2025-01-30',
    scheduledDate: isoForOffset(3),
    scheduledTime: '10:00',
  },
]

export const weeklyAppointments: WeeklyAppointment[] = [
  {
    id: 'appt-1',
    title: 'Pipeline Sync',
    time: '10:00',
    location: 'Berlin HQ',
    contact: 'Anna Schmidt',
    notes: 'Review key accounts',
    date: isoForOffset(0),
  },
  {
    id: 'appt-2',
    title: 'Hamburg Lead Follow-up',
    time: '13:00',
    location: 'Virtual',
    contact: 'Luca Meyer',
    date: isoForOffset(1),
  },
  {
    id: 'appt-3',
    title: 'Munich Partner Briefing',
    time: '15:30',
    location: 'Field Office',
    contact: 'Sven Richter',
    date: isoForOffset(2),
  },
]

export const strategicRegions: StrategicRegion[] = [
  { id: 'region-berlin-mitte', name: 'Berlin Mitte', plz: '10115', leadCount: 12, isAssigned: true },
  { id: 'region-hamburg-nord', name: 'Hamburg Nord', plz: '22335', leadCount: 9, isAssigned: false },
  { id: 'region-munich-west', name: 'München West', plz: '80636', leadCount: 7, isAssigned: false },
  { id: 'region-stuttgart-sued', name: 'Stuttgart Süd', plz: '70180', leadCount: 6, isAssigned: false },
  { id: 'region-frankfurt', name: 'Frankfurt Innenstadt', plz: '60311', leadCount: 10, isAssigned: true },
]

export const holidaysByBundesland: Record<string, Holiday[]> = {
  BW: [
    { date: '2024-12-25', name: 'Weihnachten', bundesland: 'BW' },
    { date: '2024-12-26', name: '2. Weihnachtsfeiertag', bundesland: 'BW' },
    { date: '2025-01-06', name: 'Heilige Drei Könige', bundesland: 'BW' },
  ],
  BY: [
    { date: '2024-12-25', name: 'Weihnachten', bundesland: 'BY' },
    { date: '2024-12-26', name: '2. Weihnachtsfeiertag', bundesland: 'BY' },
    { date: '2025-01-06', name: 'Heilige Drei Könige', bundesland: 'BY' },
  ],
  default: [
    { date: '2024-12-25', name: 'Weihnachten' },
    { date: '2024-12-26', name: '2. Weihnachtsfeiertag' },
    { date: '2025-01-01', name: 'Neujahr' },
  ],
}
